var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-calc" }, [
    _c("div", { staticClass: "topbar row no-margin" }, [
      _c(
        "div",
        {
          staticClass: "display row no-margin col-8 align-items-center",
          style: "font-size:" + _vm.fontSize + "px"
        },
        [
          _c(
            "div",
            {
              staticClass: "col no-padding text-right font-weight-bold",
              class: [
                {
                  "text-danger": _vm.compare
                    ? _vm.displayNumber < _vm.totalNumber
                    : !_vm.isValid,
                  "text-success": _vm.compare
                    ? _vm.displayNumber >= _vm.totalNumber
                    : _vm.isValid
                }
              ]
            },
            [
              _c(
                "span",
                { class: [{ "default-number": _vm.isDefaultShowNumber }] },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.displayNumber || "0") +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "delete col-4" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-clear",
            class: [{ active: _vm.btnActive == "key-clear" }],
            on: {
              click: function($event) {
                return _vm.clear()
              }
            }
          },
          [_c("i", { staticClass: "fas fa-backspace" })]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "outer-btn row no-margin" }, [
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-1",
            class: [{ active: _vm.btnActive == "key-1" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("1", $event)
              }
            }
          },
          [_vm._v("1")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-2",
            class: [{ active: _vm.btnActive == "key-2" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("2", $event)
              }
            }
          },
          [_vm._v("2")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-3",
            class: [{ active: _vm.btnActive == "key-3" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("3", $event)
              }
            }
          },
          [_vm._v("3")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "outer-btn row no-margin" }, [
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-4",
            class: [{ active: _vm.btnActive == "key-4" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("4", $event)
              }
            }
          },
          [_vm._v("4")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-5",
            class: [{ active: _vm.btnActive == "key-5" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("5", $event)
              }
            }
          },
          [_vm._v("5")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-6",
            class: [{ active: _vm.btnActive == "key-6" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("6", $event)
              }
            }
          },
          [_vm._v("6")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "outer-btn row no-margin" }, [
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-7",
            class: [{ active: _vm.btnActive == "key-7" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("7", $event)
              }
            }
          },
          [_vm._v("7")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-8",
            class: [{ active: _vm.btnActive == "key-8" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("8", $event)
              }
            }
          },
          [_vm._v("8")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-9",
            class: [{ active: _vm.btnActive == "key-9" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("9", $event)
              }
            }
          },
          [_vm._v("9")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "outer-btn row no-margin" }, [
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-dot",
            class: [{ active: _vm.btnActive == "key-dot" }],
            staticStyle: { "font-weight": "bold" },
            on: {
              click: function($event) {
                return _vm.onPressButton(".", $event)
              }
            }
          },
          [_vm._v(".")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-0",
            class: [{ active: _vm.btnActive == "key-0" }],
            on: {
              click: function($event) {
                return _vm.onPressButton("0", $event)
              }
            }
          },
          [_vm._v("0")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 inner-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn col key-enter",
            class: [
              {
                active: _vm.btnActive == "key-enter",
                "btn-web": _vm.displayNumber >= _vm.totalNumber
              }
            ],
            attrs: { disabled: !_vm.isValid || _vm.disabled },
            on: {
              click: function($event) {
                return _vm.enter()
              }
            }
          },
          [_vm._v("Enter")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3e56e20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3e56e20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/Calculator.vue
// module id = null
// module chunks = 